export default "__VITE_ASSET__BCL$s9$z__"